import { render } from "./ReservationReport.vue?vue&type=template&id=312fe1d9"
import script from "./ReservationReport.vue?vue&type=script&lang=js"
export * from "./ReservationReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__